/* eslint-disable no-shadow */
import React from 'react';
import { useSelector } from 'react-redux';

import RatingInfoNew from '../../InfoPopUps/RatingInfoNew';
import PBRScale from './PBRScale';
import useIsMobile from '../../hooks/useIsMobile';

import styles from './ratingDisplayV3.scss';

const RatingV3 = props => {
    const { title, titleColor, value, footer, ballColor, showRatingInfo, isVerified, showProgressionBall, showGetRatedButton = false, onGetRatedClick, ratingInfoType = 'ratingInfo', 'data-testid': dataTestId } = props;
    const { isMobileWidth } = useIsMobile();
    const auth = useSelector(({ auth }) => auth);
    const userLoggedIn = !!auth.user;

    const getRatingInfo = () => {
        if (showRatingInfo) {
            return (
                <RatingInfoNew
                    rootClass={styles.ratingInfoRoot}
                    anchorClass={styles.ratingInfoAnchor}
                    cancelText="Got it"
                    user={userLoggedIn}
                    isMobile={isMobileWidth}
                    type={ratingInfoType}
                    infoIcon="/img/v3/icons/icon-14px-info-grey.svg"
                />
            );
        }
        return null;
    };

    return (
        <div className={styles.rating} data-testid={dataTestId}>
            <div className={`${styles.title} ${titleColor}`} data-testid={dataTestId ? `${dataTestId}.title` : undefined}>
                {title} {ballColor && <div className={`${styles.progBall} ${ballColor}`} />}{isVerified && <div className="verified" />}
            </div>
            {showGetRatedButton && onGetRatedClick ? (
                <div className={styles.value}>
                    <div className={styles.btnWrapper}>
                        <button
                            type="button"
                            className={'btn btn-white btn-inv btn-sm text-uppercase'}
                            onClick={onGetRatedClick}
                            data-testid={dataTestId ? `${dataTestId}.get-rated-btn` : undefined}
                        >
                            Get Rated
                        </button>
                    </div>
                </div>
            ) : (
                <div className={styles.value} data-testid={dataTestId ? `${dataTestId}.value` : undefined}>
                    {value === 'Unrated' ? 'UR' : value}
                </div>
            )}
            <div className={styles.footer} data-testid={dataTestId ? `${dataTestId}.footer` : undefined}>
                {showProgressionBall && (
                    <div className={styles.pbrScaleWrapper}>
                        <PBRScale value={showProgressionBall} /> {getRatingInfo()}
                    </div>
                )}
                {footer && (
                    <div className={showProgressionBall && 'mt6'}>{footer}</div>
                )}
                {!showProgressionBall && showRatingInfo && getRatingInfo()}
            </div>
        </div>
    );
};

export default RatingV3;
